module.exports = __webpack_public_path__ + "pic_bizny_web_03@2x.png?245025c369bfdf79841ad774ff82aef3";